<div class="page-section-input-container"
     [class.selected]="selected"
     [class.static]="static">
  <div contenteditable="false"
       [class.empty]="section.title_control?.value === ''"
       [attr.data-placeholder]="section.section_title && section.title_control.value ? '': 'Enter the section title'"
       class="noneSelectable page-section-title">
    {{ (section.title_control.valueChanges|async) || section.title_control.value }}
  </div>
</div>
